exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-black[data-v-11ddcc0d]{-webkit-filter:invert(100%);filter:invert(100%)}\n", ""]);

// exports
